var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategiclogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_420)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2818 43.1555C25.715 43.1555 27.6881 45.1299 27.6881 47.5641V52.708C27.6881 55.1422 25.715 57.1166 23.2818 57.1166H20.3437C17.9106 57.1166 15.9375 55.1422 15.9375 52.708V47.5641C15.9375 45.1299 17.9106 43.1555 20.3437 43.1555H23.2818ZM37.9687 36.5426C40.4028 36.5426 42.375 38.517 42.375 40.9512V52.708C42.375 55.1422 40.4028 57.1166 37.9687 57.1166H35.0315C32.5984 57.1166 30.6253 55.1422 30.6253 52.708V40.9512C30.6253 38.517 32.5984 36.5426 35.0315 36.5426H37.9687ZM52.6565 27.7254C55.0897 27.7254 57.0628 29.6998 57.0628 32.134V52.708C57.0628 55.1422 55.0897 57.1166 52.6565 57.1166H49.7193C47.2853 57.1166 45.3131 55.1422 45.3131 52.708V32.134C45.3131 29.6998 47.2853 27.7254 49.7193 27.7254H52.6565ZM52.1525 20.9291L19.5964 39.2925C18.8905 39.6908 17.9943 39.4405 17.596 38.7343C17.1977 38.0274 17.4479 37.1307 18.1538 36.7323L50.7169 18.365L49.0813 17.9753C48.2926 17.7872 47.8053 16.9944 47.993 16.2048C48.1807 15.416 48.9738 14.9279 49.7625 15.116L54.7627 16.3079C55.5523 16.4961 56.0397 17.2888 55.8511 18.0784L54.6596 23.0814C54.4719 23.8702 53.6797 24.3583 52.8909 24.1702C52.1022 23.9828 51.6149 23.1893 51.8026 22.4004L52.1525 20.9291Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_420",
    x1: 2,
    y1: 2.5,
    x2: 71,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategiclogo3);
export default __webpack_public_path__ + "static/media/strategiclogo3.dcf3fdad6ad2176647a414ef50c0fd33.svg";
export { ForwardRef as ReactComponent };